import { render } from "./Widget15.vue?vue&type=template&id=0f8eb598&scoped=true"
import script from "./Widget15.vue?vue&type=script&lang=js"
export * from "./Widget15.vue?vue&type=script&lang=js"

import "./Widget15.vue?vue&type=style&index=0&id=0f8eb598&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8eb598"]])

export default __exports__